/**
 * The allowlist for what a chat `<img>` may point at.
 *
 * Chat figures arrive as an ordinary markdown image whose src the MODEL wrote.
 * A model that invents a host is not hypothetical here: production emitted
 * `https://bower.ai/notes/<uuid>` for entity links, a domain Bower does not
 * own, and the user clicked it. Bower also serves no CSP on any surface, so
 * nothing backstops a bad src. This exact-match parse is the control.
 *
 * Deliberately a strict regex against a full-string match rather than URL
 * parsing plus checks: every "normalise then validate" shape has a bypass, and
 * there is exactly one legitimate form.
 */
const FIGURE_SRC =
  /^\/api\/attachments\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/download$/i;

export interface FigureSrc {
  readonly attachmentId: string;
}

/** The attachment id this src names, or null if it is not one of ours. */
export function parseFigureSrc(src: string | undefined): FigureSrc | null {
  if (!src) return null;
  const match = FIGURE_SRC.exec(src);
  return match ? { attachmentId: match[1] } : null;
}
